export function setVendorConsent(vendorId: string): void {
    if ('__cmp' in window && window.__cmp !== undefined) {
        window.__cmp('setVendorConsent', [vendorId, 1]);
    } else {
        console.warn('setVendorConsent', `__cmp is not available. Skipping ${vendorId}...`);
    }
}

export function getVendorConsent(vendorId: string): boolean {
    if ('__cmp' in window && window.__cmp !== undefined) {
        const cmpData = window.__cmp('getCMPData');
        return !!(cmpData && 'vendorConsents' in cmpData && vendorId in cmpData.vendorConsents && cmpData.vendorConsents[vendorId]);
    } else {
        console.warn('getVendorConsent', `__cmp is not available. Skipping ${vendorId}...`);
    }
    return false;
}

export function cmpLoaded(callback: () => void): void {
    if (!('__cmp' in window) || window.__cmp === undefined) {
        console.warn('cmpLoaded', '__cmp is not available.');
        return;
    }

    const cmpData = window.__cmp('getCMPData');

    // Already initialised
    if (cmpData && cmpData['userChoiceExists']) {
        callback();
        return;
    }

    // Otherwise wait for the consent event
    window.__cmp('addEventListener', ['consent', callback, false], null);
}

export function validVendorConsentOrOverlay(vendorId: string, callback: () => void, container: HTMLElement): void {
    if (getVendorConsent(vendorId)) {
        callback();
    } else {
        createVencorConsentOverlay(container, vendorId, callback);
    }
}

export function createVencorConsentOverlay(element: HTMLElement, vendorId: string, callback: () => void): void {
    const overlay = document.createElement('div');
    overlay.className = 'absolute inset-0 bg-darkblue bg-opacity-90 text-white flex flex-col items-center justify-center p-6 text-center z-10';
    overlay.dataset.overlayVendorId = vendorId;

    const message = document.createElement('p');
    message.className = 'mb-4 text-lg';

    const text = element.dataset.overlayText;
    if (text) {
        message.textContent = text;
    }

    const acceptButton = document.createElement('button');
    acceptButton.className = 'px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors';
    acceptButton.dataset.vendorId = vendorId;

    const label = element.dataset.overlayLabel;
    if (label) {
        acceptButton.textContent = label;
    }
    document.addEventListener('click', (event) => {
        const target = event.target as HTMLElement;
        if (target.matches(`[data-vendor-id="${vendorId}"]`)) {
            setVendorConsent(vendorId);
            document.querySelectorAll(`[data-overlay-vendor-id="${vendorId}"]`).forEach((overlay) => {
                overlay.remove();
            });
            callback();
        }
    });

    overlay.appendChild(message);
    overlay.appendChild(acceptButton);
    element.style.position = 'relative';
    element.appendChild(overlay);
}

export function hideCmpSettingsButton(): void {
    const consentButton = document.querySelector('#cmpboxrecall') as HTMLElement;
    if (consentButton) {
        consentButton.style.display = 'none';
    }
}

export function showCmpSettingsButton(): void {
    const consentButton = document.querySelector('#cmpboxrecall') as HTMLElement;
    if (consentButton) {
        consentButton.style.display = 'block';
    }
}
